// extracted by mini-css-extract-plugin
export var attachment = "_pj-a";
export var emailContainer = "_pj-4";
export var emailContentPaddedContainer = "_pj-b";
export var emailHeader = "_pj-6";
export var emailIframe = "_pj-3";
export var emailInfoIcon = "_pj-9";
export var emailShortenedSummary = "_pj-e";
export var infoDropdown = "_pj-0";
export var infoRowBoundedContent = "_pj-d";
export var internal = "_pj-5";
export var merchant = "_pj-8";
export var messageInputContainer = "_pj-h";
export var normal = "_pj-7";
export var replyCard = "_pj-f";
export var subtleButton = "_pj-1";
export var subtleButtonIconContainer = "_pj-2";
export var toggleViewRepliesButton = "_pj-c";
export var wrappingText = "_pj-g";